export default import.meta.ROLLDOWN_FILE_URL_6aR8AhYQ8J_mec4trO$H8g